export const queryKeyUseInsightsPerDateQuery = (date: Date, processingStatus: boolean) => [
    'queryKeyUseInsightsPerDateQuery',
    date,
    processingStatus,
];
